<template>
  <div id="booking-info" class="container">
    <loading-modal v-if="this.show_loadding_api"></loading-modal>
    <booking-success-modal v-if="show_modal_booking_success" 
      v-bind:show_modal_booking_success="show_modal_booking_success" 
      @close_modal="show_modal_booking_success = $event">
    </booking-success-modal>
    <alert-modal v-if="show_modal_alert_error" 
      v-bind:show_modal_alert_error="show_modal_alert_error" 
      @close_modal="show_modal_alert_error = $event">
    </alert-modal>
    <div class="section-info-booking default-section">
      <h3>Đặt lịch hẹn</h3>
      <div class="row">
        <div class="col-md-6">
          <label>Chọn Cố vấn <span style="color:red">*</span></label>
          <multiselect
              v-model='booking_info.counselor' 
              :options="list_counselors"
              label="name"  
              placeholder="Chọn Cố vấn"
              @input="onChange"
              :show-labels="false">              
          </multiselect> 
        </div>
        <div class="resume-category col-md-6">
          <label>Chọn dịch vụ <span style="color:red">*</span></label>
          <multiselect
            v-model="booking_info.services"
            :options="service_options"
            :multiple='true'
            :taggable="true" 
            :close-on-select="true"
            placeholder='Chọn dịch vụ'          
            label="name"
            track-by="name"
          ></multiselect>
          <pre>{{booking_info.service}}</pre>
        </div>
        <div class="col-md-6">
          <label>Ngày bạn muốn đặt lịch hẹn (theo giờ Việt Nam) <span style="color:red">*</span></label>
          <input v-model='booking_info.date_meeting' type="date" class="form-control">
        </div>
        <div class="col-md-6">
          <label>Khung giờ bạn muốn đặt lịch hẹn (theo giờ Việt Nam) <span style="color:red">*</span></label>
          <multiselect 
            v-model='booking_info.time_of_the_day' 
            :options="time_options" 
            placeholder="Chọn khung giờ" 
            :allow-empty="false"
            :show-labels="false">              
          </multiselect> 
        </div>
        <div class="col-md-12">
          <label>Các câu hỏi chi tiết dành cho Cố vấn</label>
          <textarea v-model="booking_info.question" class="form-control" id="exampleFormControlTextarea1" rows="10"></textarea>
        </div>
      </div>
    </div>
    <!-- <div class="section-customer-info default-section">
      <h3>Thông tin cá nhân</h3>
      <div class="row">
        <div class="name col-md-6">
          <span> Tên của bạn <span style="color:red">*</span></span>          
          <input v-model="booking_info.customer_name" type="text" name="" class="form-control" placeholder="Họ và tên đầy đủ của bạn">
        </div>
        <div class="email col-md-6">
          <small>Email <span style="color:red">*</span></small>
          <input v-model='booking_info.customer_email' type="text" name="" class="form-control" placeholder="you@yourdomain.com">
        </div>              
        <div class="date-of-birth col-md-6">
          <small>Ngày tháng năm sinh <span style="color:red">*</span></small>          
          <input v-model='booking_info.date_of_birth' type="date" data-input="true" name="" class="form-control datepicker flatpickr-input" placeholder="dd/mm/yy">
        </div>
        <div class="address col-md-6">
          <small>Nơi đang sinh sống <span style="color:red">*</span></small> 
          <input v-model='booking_info.customer_address' type="text" name="" class="form-control" placeholder='Ví dụ như "Hanoi, Vietnam," "New York, NY"'>
        </div>
        <div class="phone-number col-md-6">
          <small>Số điện thoại <span style="color:red">*</span></small>
          <input v-model='booking_info.customer_phone' type="tel" name="" class="form-control" placeholder="">
        </div>
        <div class="linkedin col-md-6">
          <small>LinkedIn</small>
          <input v-model='booking_info.customer_linkedin' type="text" name="" class="form-control" placeholder="your linkedIn page link">
        </div>
      </div>
    </div> -->
    <div class="section-education-info default-section">
      <h3>Học tập</h3>
      <div class="row">
        <div class="col-md-6">
          <label></label>Trình độ học vấn cao nhất <span style="color:red">*</span></label>
          <multiselect 
            v-model='booking_info.level_education' 
            :options="list_level_education" 
            placeholder="Chọn trình độ học vấn" 
            :allow-empty="false"
            :show-labels="false">   
          </multiselect> 
        </div>
        <div class="col-md-6">
          <label>Điểm GPA gần nhất <span style="color:red">*</span></label>
          <input type="number" v-model="booking_info.GPA_score" class="form-control">
        </div>
      </div>
    </div>
    <div class="section-result_exam default-section">
      <h3>Điểm bài thi chuẩn hóa</h3>
      <div class="row">
        <div v-for="sc in booking_info.score" class="col-md-6">
          <small>{{sc['name'].toUpperCase()}}</small>
          <input v-model="sc['score']" type="number" class="form-control">
        </div>
      </div>
    </div>
    <button id="booking-button" @click="validate_require_field($event); booking()" class="btn btn-default"> Đặt lịch hẹn </button>
  </div>

</template>
<script>
  import Multiselect from 'vue-multiselect';
  import BookingSuccessModal from '../Modal/BookingSuccess.vue';
  import AlertModal from '../Modal/AlertModal.vue'
  import LoadingModal from '../Modal/LoadingModal.vue'
  import router from '../../../router';
  import {mapState, mapActions, mapGetter} from 'vuex';
  var url = process.env.API_URL + process.env.API_VERSION;
  var list_field_required = ['services', 'date_meeting', 'time_of_the_day', 'customer_name', 'date_of_birth', 'customer_email', 'customer_phone', 'customer_address', 'level_education', 'GPA_score']
  export default{
    props: ['info_page'],
    components: {
      Multiselect,
      BookingSuccessModal,
      AlertModal,
      LoadingModal
    },    
    data: function(){      
      return {
        booking_info: {
          counselor: {            
            'name': this.info_page.counselor.name,
            'id': this.info_page.counselor.id ,
          },
          services: [],
          date_meeting: '',
          question: '',
          time_of_the_day: '',
          customer_name: '',
          date_of_birth: '',
          customer_email: '',
          customer_phone: '',
          customer_address: '',
          customer_linkedin: '',
          level_education: '',
          GPA_score: '',
          score: [
            {name: 'ielts',   score: ''},
            {name: 'toefl',   score: ''},
            {name: 'toeic',   score: ''},
            {name: 'sat',     score: ''},
            {name: 'act',     score: ''},
            {name: 'gmat',    score: ''},
            {name: 'gre',     score: ''},            
          ]
        },
        service_options: [],
        time_options: ['Sáng', 'Trưa', 'Chiều', 'Tối'],
        list_level_education: ['Trung học Cơ sở', 'Trung học Phổ thông', 'Đại học', 'Thạc sĩ', 'Tiến sĩ'],
        show_modal_booking_success: false,
        show_modal_alert_error: false,
        show_loadding_api: false,
        errors: [],
      }
    },    
    created: function(){
      this.$store.dispatch('vuex_booking_form/load_list_counselors');
      this.$store.dispatch('vuex_booking_form/load_list_services')
      if (this.$route.query.id != undefined){        
        this.booking_info.counselor.id = this.$route.query.id;        
        
      }
      this.list_counselors.forEach((counselor) =>{
        this.counselor_options.push({name: counselor.name, id: counselor.id});
      });
      if (this.booking_info.counselor.id == ''){
        this.service_options = this.list_service;
      }
      // Prepare data for auto fill function
      var current_user = JSON.parse(this.$store.state.user.user)    
      if (!(Object.keys(current_user).length === 0)) {
        this.$store.dispatch('user/get_user_info', current_user.id)
      }else{
        alert('Yêu cầu đăng nhập')
        router.push('/login')
      }
    },
    beforeMount(){

    },
    mounted(){           
    },
    computed:{
      ...mapState('vuex_booking_form',[
        'list_service'
      ]),
      ...mapState('vuex_booking_form', {
        list_counselors: (state) => {
          return state.list_counselors
        }
      }),
      ...mapState('user', {
        current_user_info: (state) => {           
          return state.user_info
        },
        current_user_info_basic: (state) =>{
          return state.user
        },
        user_token: (state) => {
          return state.token
        }
      })
    },    
    watch:{
      list_counselors: {
        handler(newval, oldval){
          this.list_counselors.forEach((counselor)=> {
          if (counselor.id == this.booking_info.counselor.id){
            this.booking_info.counselor.name = counselor.name;
            this.service_options = counselor.service_detail
            this.booking_info.services = []
            return;
          }
          });
        },
        // deep: true
      },
      // updae info of curren user
      current_user_info(newval, oldval){
        var require_info = ['name', 'email', 'phone', 'date_of_birth', 'address', 'level_education']
        var current_user_info_basic = JSON.parse(this.current_user_info_basic)
        var url_edit = '/edit_profile?id=' + current_user_info_basic.id
        require_info.some((field) => {
          if (newval[field] == ''){
            alert('Bạn phải cập nhật thông tin cá nhân trước')
            router.push(url_edit)
            return true
          }
        })
        this.booking_info.customer_name = newval.name
        this.booking_info.customer_email = newval.email        
        this.booking_info.customer_phone = newval.phone
        this.booking_info.date_of_birth = newval.date_of_birth
        this.booking_info.customer_address = newval.address
        this.booking_info.customer_linkedin = newval.linkedin
        this.booking_info.level_education = newval.level_education
        this.booking_info.GPA_score = newval.GPA_score
        this.booking_info.score.forEach((ele)=>{
          ele.score = newval.score[ele.name]
        })
      },
    },
    methods: {
      onChange: function(){
        var counselor_id = this.booking_info.counselor.id;        
        this.list_counselors.forEach((counselor) => {
          if(counselor_id == counselor.id){
            this.service_options = counselor.service_detail;
            this.booking_info.services = [];
          }
        });
      },
      booking: function(){        
        if (!this.show_modal_alert_error){
          this.show_loadding_api = true
          this.$http
            .post(url + '/appointment/create',
              this.booking_info,
              { headers: 
                { 
                  'Authorization': this.user_token,
                  'Access-Control-Allow-Origin': '*',
                  'Content-type': 'application/json'           
                } 
              })
            .then((response) => {
              this.show_loadding_api = false
              // this.show_modal_booking_success = true
              var link = '/thankyou?a_id=' + response.data.extra.appointment_id
              router.push(link)
            })
            .catch((error) => {
              this.show_loadding_api = false
              if(error.response != undefined){
                alert(error.response.data.messages)
              }
            })
        }        
      },
      validate_require_field: function(event){
        for (var field in list_field_required){
          if (  this.booking_info[list_field_required[field]] == '' || 
                this.booking_info[list_field_required[field]].length <= 0) {
            this.errors[list_field_required[field]] = 'Trường bắt buộc';
          }else{
            delete this.errors[list_field_required[field]];
          }
        }
        if (Object.keys(this.errors).length > 0 ){
          this.show_modal_alert_error = true
        }else{
          this.show_modal_alert_error = false
        }
      },      
    }
  };
</script>
<style lang="scss" scoped>
  @import "./booking_info";
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/views/components/Booking/BookingInfo.vue